import React from 'react';
import { FlexRow } from '../FlexRow';
import { BoldSmallBodyText, SmallBodyText } from '../Typography';

export const HeaderSubItem: React.FC<{ label?: string; value: any }> = ({ label, value }) => (
  <FlexRow>
    {label ? <BoldSmallBodyText>{label}</BoldSmallBodyText> : null}
    <SmallBodyText>{value}</SmallBodyText>
  </FlexRow>
);
